import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/context/LanguageContext";
import HubPage from "@/pages/HubPage";
import ClientLanding from "@/pages/ClientLanding";
import OrientationPage from "@/pages/OrientationPage";
import PrivatePage from "@/pages/PrivatePage";
import HandbookPage from "@/pages/HandbookPage";
import SuccessPage from "@/pages/SuccessPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ManageBookingPage from "@/pages/ManageBookingPage";
import PrivacyPage from "@/pages/legal/PrivacyPage";
import TermsPage from "@/pages/legal/TermsPage";
import NdaPage from "@/pages/legal/NdaPage";
import CookieBanner from "@/components/CookieBanner";
import "@/index.css";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HubPage />} />
            <Route path="/client" element={<ClientLanding />} />
            <Route path="/vixen" element={<PrivatePage />} />
            <Route path="/private" element={<PrivatePage />} />
            <Route path="/orientation" element={<OrientationPage />} />
            <Route path="/recruit" element={<OrientationPage />} />
            <Route path="/handbook" element={<HandbookPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/booking/manage/:token" element={<ManageBookingPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/nda" element={<NdaPage />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
